import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import notifiction from '../../assets/images/notifiction-icon.svg'
import { fynitoApi } from '../Services/axios'
import toastify from '../../helper/toastify'
import MobileBottomBar from '../Layout/MobileBottomBar';
const Notification = () => {
    const [notifications, setNotifications] = useState([]);

    // Fetch Notification Api
    const fetchNotificationList = async () => {
        try {
            const res = await fynitoApi.get('/notification-list');
            if (res.data.status_code === 200) {
                setNotifications(res.data.data.data)
            } else {
                toastify.error(res.data.message);
            }
        } catch (error) {
        }
    }

    // All Notification Clear Api
    const clearAllNotifications = async () => {
        try {
            const res = await fynitoApi.delete('/all-notification-clear');
            if (res.data.status_code === 200) {
                toastify.success(res.data.message);
                setNotifications([]);
            } else {
                toastify.error(res.data.message);
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        fetchNotificationList();
    }, [])

    return (
        <>
            <section className="bredcump-sec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Notifications
                                    </li>
                                </ol>
                            </nav>
                            <h3 className="title">Notifications</h3>
                        </div>
                        <div className="col-lg-6 text-end">
                            {notifications.length > 0 && (
                                <button
                                    className="btn btn-sm btn-danger mt-3"
                                    onClick={clearAllNotifications}
                                >
                                    Clear All
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </section>
            <section className='notification-sec tp-space pt-0'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12">
                            <ul className="notification-list">
                                {
                                    notifications?.length > 0 ? (
                                        notifications.map((noti, index) => {
                                            return (
                                                <li key={noti.id}>
                                                    <div className="notification-icon">
                                                        <img src={noti.image} alt="notifiction" />
                                                    </div>
                                                    <div className="notification-content">
                                                        <h6>{noti.title}</h6>
                                                        <p>{noti.time_ago}</p>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    ) : (
                                        <p className='text-center text-danger'><i className="fa-solid fa-bell mb-2"></i> <br />No Notifications Found</p>
                                    )
                                }
                            </ul>
                        </div>
                    </div>

                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default Notification